import { Button, Kind } from '@thanx/uikit/button'
import { buildTranslate } from 'locales'

const t = buildTranslate('components.ai.segment_activation_modal')

interface ActivationModalActionsProps {
  isSaving: boolean
  onCancelClicked: () => void
  onSaveClicked: () => void
}

const ActivationModalActions = ({
  isSaving,
  onCancelClicked,
  onSaveClicked,
}: ActivationModalActionsProps) => (
  <div className="d-flex justify-content-end mt-l">
    <Button
      kind={Kind.SECONDARY}
      onClick={onCancelClicked}
      className="mr-m"
      disabled={isSaving}
    >
      {t('cancel_button')}
    </Button>
    <Button kind={Kind.PRIMARY} onClick={onSaveClicked} isLoading={isSaving}>
      {t('save_button')}
    </Button>
  </div>
)

export default ActivationModalActions
